import Hotjar from '@hotjar/browser'

const siteId = process.env.REACT_APP_HOTJAR_ID
const hotjarVersion = 6

Hotjar.init(siteId, hotjarVersion, {
  debug: true
})

export default Hotjar
